import { openBlock as t, createElementBlock as h, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M15.5 3.5v9H.5v-9h15Zm-1 1h-13v7h13v-7Z",
  "clip-rule": "evenodd"
}, null, -1), l = /* @__PURE__ */ e("path", { d: "M11.996 8.14c0 .413-.078.758-.235 1.035a1.46 1.46 0 0 1-.65.62 2.23 2.23 0 0 1-.99.205H8.966V6.43h1.235c.573 0 1.015.147 1.325.44.313.293.47.717.47 1.27Zm-1 .035c0-.643-.262-.965-.785-.965h-.28v2h.215c.293 0 .508-.085.645-.255.137-.17.205-.43.205-.78ZM5.687 10l-.73-2.57h-.02c.007.067.013.157.02.27l.02.37c.007.133.01.26.01.38V10h-.855V6.43h1.285l.745 2.535h.02l.73-2.535h1.285V10h-.885V8.435c0-.11.002-.23.005-.36l.01-.365a6.86 6.86 0 0 1 .02-.275h-.02L6.607 10h-.92Z" }, null, -1), n = [
  o,
  l
];
function d(r, s) {
  return t(), h("svg", c, [...n]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
